import { useWallet } from '@solana/wallet-adapter-react';
import axios from 'axios';
import { createContext, useContext, useEffect, useState } from 'react';

export const PendingBetsContext = createContext({});

export const usePendingBetsContext = () => useContext(PendingBetsContext);

export const PendingBetsProvider = ({ children }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState();
  const [placedHashes, setPlacedHashes] = useState([]);
  const wallet = useWallet();
  
  const { connected, publicKey } = wallet;
  
  const pendingBets = async () => {
    setIsLoading(true);
    try {
      var outputRaw = await axios.get("https://p43l0w1hu4.execute-api.ap-northeast-1.amazonaws.com/default/pendingBetsV2?chain=eclipse&addr=" + publicKey.toBase58());
      // console.log(outputRaw);
      var output = outputRaw.data;
      output.sort((a, b) => {
        return a.eventStart - b.eventStart;
      });
      setData(output);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const removeBet = (acc) => {
    var updatedData = [];
    for(var b = 0; b < data.length; b++){
      if(data[b].betAddr == acc){
        continue;
      }
      updatedData.push(data[b]);
    }
    setData(updatedData);
  };

  // send hash in case of placing bet, so that we can not show cancel button for 35 seconds.
  const refreshData = async (hash = '') => {
    await pendingBets();
  };

  const placingBet = (done = true) => {
    console.debug("placingBet done: " + done);
    setIsLoading(!done);
  }

  const updatingAccs = (done = true, timeout = false) => {
    console.debug("updatingAccs done: " + done + "; timeout: " + timeout);
    setIsLoading(!done && !timeout);
  }

  const clearPlacedBetWaitTime = (hash = '') => {
    if (hash && placedHashes.indexOf(hash) > -1) {
      setPlacedHashes(placedHashes.filter((item) => item !== hash));
    }
  };

  const addBet = (betObj) => {
    console.log("addBet() has been called with " + betObj);
    //append this bet to data
    var newData = JSON.parse(JSON.stringify(data));
    newData.push(betObj);
    newData.sort((a, b) => {
      return a.eventStart - b.eventStart;
    });
    setData(newData);
  };

  useEffect(() => {
    // It gets data initially as well as when the deps array chaange.
    if (connected) {
      refreshData();
    }
  }, [connected]);
  return <PendingBetsContext.Provider value={{ data, refreshData, isLoading, placingBet, updatingAccs, addBet, removeBet }}>{children}</PendingBetsContext.Provider>;
};
